import { render, staticRenderFns } from "./ProcessCompare.vue?vue&type=template&id=1c6640c4&"
import script from "./ProcessCompare.vue?vue&type=script&lang=js&"
export * from "./ProcessCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports